<template>
  <div class="cool-m-l-protocol-block_wrap">
    <div class="check_box-container">
      <input name="read_protocol" type="checkbox" class="read_protocol_check_box"
        :id="checkBoxID"
        :checked="checkValue"
        @change="changeHandle"/>
      <label
        :for="checkBoxID"></label>
    </div>
    <p class="protocal-txt">
      我已阅读并接受
      <a href="//igetcool-share.igetcool.com/h5share/activity?h5Pid=713482655731159040&activityPid=713482655731159040">《使用协议》</a>
      <a href="//igetcool-share.igetcool.com/h5share/activity?h5Pid=713541320089669632&activityPid=713541320089669632">《隐私协议》</a>
      <a href="//igetcool-share.igetcool.com/h5share/activity?h5Pid=713538697831780352&activityPid=713538697831780352">《儿童隐私协议》</a>
      <slot/>
    </p>
  </div>
</template>

<script>
export default {
  name: 'IGetCoolMProtocal',

  model: {
    prop: 'hasRead',
    event: 'modelHasRead'
  },

  props: {
    hasRead: Boolean
  },

  data() {
    return {
      checkValue: this.hasRead,
      checkBoxID: 'read_protocol_check_box_' + new Date().getTime()
    };
  },

  // watch: {
  //   hasRead: {
  //     handler(v) {
  //       this.checkValue = v;
  //     },
  //     immediate: true
  //   }
  // },

  methods: {
    changeHandle($evt) {
      const checked = Boolean($evt.target.checked);
      this.$emit('modelHasRead', checked);
      this.$emit('change', checked);
    }
  }
};
</script>

<style lang='stylus'>
.cool-m-l-protocol-block_wrap
  display flex
  justify-content center
  .check_box-container
    width .14rem
    height .14rem
    margin-right .04rem
    margin-top .025rem
    font-size 0
    input
      display none
      outline none
    label
      display inline-block
      width .14rem
      height .14rem
      border-radius .05rem
      border 1px solid #8e8f92
      position relative
      cursor pointer
      margin-top -.01rem
      outline none
    label::before
      display inline-block
      content " "
      width .09rem
      border 2px solid #8e8f92
      height .04rem
      border-top none
      border-right none
      transform rotate(-45deg)
      top .03rem
      left .02rem
      position absolute
      opacity 0
    input:checked+label::before
      opacity 1
      transform all 0.5s
  .protocal-txt
    display inline-block
    width 2.54rem
    line-height .2rem
    font-size .14rem
    color rgb(194, 194, 202)
    text-align center

    a
      color rgb(142, 143, 146)
      text-decoration none

</style>
